import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  Bcbs_Tn_SSO_ActionTypes,
  LoggedInUserActionTypes,
  Refresh_Token_SSO_ActionTypes,
  RegisterUserActionTypes,
  ResetPassActionTypes,
  UserByClaimsActionTypes,
  UserLogoutActionTypes,
  UserPageTrackActionTypes,
  UserPageTrackSsoHppClaimsStatusUrlActionTypes,
  UserPageTrackSsoHpsClaimsStatusUrlActionTypes,
  UserSendMfaInfoActionTypes,
  UserVerifyMfaInfoActionTypes,
} from "../models/dispatchTypes/User";
import {
  Bcbs_Tn_SSO_ActionDispatchTypes,
  LoggedInUserDetailsActionDispatchTypes,
  Refresh_Token_SSO_ActionDispatchTypes,
  RegisterUserActionDispatchTypes,
  ResetPassActionDispatchTypes,
  SendForgotPasswordLinkActionDispatchTypes,
  SsoHppClaimsStatusUrlActionDispatchTypes,
  SsoHpsClaimsStatusUrlActionDispatchTypes,
  UserByClaimsActionDispatchTypes,
  UserLogoutActionDispatchTypes,
  UserMfaInfoActionDispatchTypes,
  UserPageTrackActionDispatchTypes,
  UserVerifyMfaInfoActionDispatchTypes,
} from "../constants/User";
import {
  GetRefreshToken,
  GetSAMLUrl,
  GetSsoHppUrl,
  GetSsoHpsUrl,
  GetUserByClaims,
  getUserDetailByEmail,
  LogoutPortalApp,
  PostRegisterUser,
  PostResetPassword,
  ResendMfaCode,
  SendForgotPasswordLink,
  SendMfaCode,
  UserPageTrack,
  VerifyMfaCode,
} from "../services/User";
import { configUrl } from "../constants/Config";
import toastType from "../utils/SnackbarProvider";
import { RefreshTokenPayload, RegisterUser, SendLink, SsoHpsUrlPayload, UserMfaInfo, UserPageTrack as UserPageTrackType } from "../models/User";
import { ApplicationState } from "../redux/ApplicationState";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";
import { getValue } from "../utils";

export const getLoggedInUserByEmail: ActionCreator<
  ThunkAction<void, any, Record<string, never>, LoggedInUserActionTypes>
> = (userEmail: string, flow: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_LOADING,
    });
    const payload = { emailId: userEmail };
    const response = await getUserDetailByEmail(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          toastType.error("Something went wrong user not found !");
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            flow: flow,
            type: LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const responseDispatch = (
  response: any,
  dispatch: Dispatch,
  type: any
) => {
  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
      case 500:
      case 404:
        typeof response.data === "string" && toastType.error(response.data);
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: type,
        });
        break;
      default:
        break;
    }
  }
};

export const sendMfaCode: ActionCreator<
  ThunkAction<void, any, Record<string, never>, UserSendMfaInfoActionTypes>
> = (payload: UserMfaInfo) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_LOADING,
    });
    const response = await SendMfaCode(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          dispatch({
            error: response,
            type: UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};
export const verifyMfaCode: ActionCreator<
  ThunkAction<void, any, Record<string, never>, UserVerifyMfaInfoActionTypes>
> = (payload: UserMfaInfo) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_LOADING,
    });
    const response = await VerifyMfaCode(configUrl, payload);
    responseDispatch(
      response,
      dispatch,
      UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_SUCCESS
    );
  };
};

export const resendMfaCode: ActionCreator<
  ThunkAction<void, any, Record<string, never>, UserSendMfaInfoActionTypes>
> = (payload: UserMfaInfo) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_LOADING,
    });
    const response = await ResendMfaCode(configUrl, payload);
    responseDispatch(
      response,
      dispatch,
      UserMfaInfoActionDispatchTypes.USER_SEND_MFA_CODE_SUCCESS
    );
  };
};

export const postRegisterUser: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RegisterUserActionTypes
  >
> = (payload: RegisterUser, headers: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RegisterUserActionDispatchTypes.POST_REGISTER_USER_INVOKE,
    });
    const response = await PostRegisterUser(configUrl, payload, headers);
    if (response && response.status) {
      switch (response.status) {
        case 400:
          typeof response.data === "string" && toastType.error(response.data);
          if (response.data.includes("already exists")) {
            dispatch({
              error: response.data,
              type: RegisterUserActionDispatchTypes.POST_REGISTER_USER_ERROR,
            });
          }
          break;
        case 422:
        case 500:
        case 404:
          toastType.error(ResponseMessages(MessageType.REGISTER_USER_FAILURE));
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: RegisterUserActionDispatchTypes.POST_REGISTER_USER_SUCCESS,
          });
          toastType.success(
            ResponseMessages(MessageType.REGISTER_USER_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const getUserByClaims: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserByClaimsActionTypes
  >
> = (headers: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_INVOKE,
    });
    const response = await GetUserByClaims(configUrl, headers);

    dispatch({
      response,
      type: UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_SUCCESS,
    });
  };
};

export const sendForgotPasswordLink: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserByClaimsActionTypes
  >
> = (payload: SendLink) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_INVOKE,
    });
    const response = await SendForgotPasswordLink(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 400:
          toastType.error(response.data);
          break;
        case 422:
        case 500:
        case 404:
          toastType.error(ResponseMessages(MessageType.FORGOT_PASS_FAILURE));
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.FORGOT_PASS_SUCCESS));
          dispatch({
            response: response.data,
            type: SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postResetPassword: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ResetPassActionTypes
  >
> = (payload: RegisterUser, headers: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ResetPassActionDispatchTypes.RESET_PASS_INVOKE,
    });
    const response = await PostResetPassword(configUrl, payload, headers);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          toastType.error(ResponseMessages(MessageType.RESET_PASS_FAILURE));
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.RESET_PASS_SUCCESS));
          dispatch({
            response: response.data,
            type: ResetPassActionDispatchTypes.RESET_PASS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};


export const postUserPageTrack: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserPageTrackActionTypes
  >
> = (payload: UserPageTrackType) => {
  return async (dispatch: Dispatch, getState: () => ApplicationState) => {
    dispatch({
      type: UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_INVOKE,
    });
    const state = getState();
    const userId = getValue(state, "loggedInUserState.response.providerPortalUser.userId");
    const userCreated = getValue(state, "loggedInUserState.response.providerPortalUser.email");
    if (userId && userCreated) {
      const response = await UserPageTrack(configUrl, { ...payload, userId: userId, userCreated: userCreated });
      if (response && response.status) {
        switch (response.status) {
          case 422:
          case 400:
          case 500:
          case 404:
            dispatch({
              error: response,
              type: UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_ERROR,
            });
            break;
          case 200:
          case 201:
            dispatch({
              response: response.data,
              type: UserPageTrackActionDispatchTypes.USER_PAGE_TRACK_SUCCESS,
            });
            break;
          default:
            break;
        }
      }
    }
  };
};

export const getSsoHpsUrl: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserPageTrackSsoHpsClaimsStatusUrlActionTypes
  >
> = (payload: SsoHpsUrlPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_INVOKE,
    });
    const response = await GetSsoHpsUrl(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: SsoHpsClaimsStatusUrlActionDispatchTypes.SSO_HPS_CLAIMS_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getSsoHppUrl: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserPageTrackSsoHppClaimsStatusUrlActionTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_INVOKE,
    });
    const response = await GetSsoHppUrl(configUrl);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getSAML: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Bcbs_Tn_SSO_ActionTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_INVOKE,
    });
    const response = await GetSAMLUrl(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
  };

export const logoutPortalApp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserLogoutActionTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserLogoutActionDispatchTypes.USER_LOGOUT_INVOKE,
    });
    try {
      const response = await LogoutPortalApp(configUrl);
      if (response && response.status) {
        switch (response.status) {
          case 422:
          case 400:
          case 500:
          case 404:
            dispatch({
              error: response,
              type: UserLogoutActionDispatchTypes.USER_LOGOUT_ERROR,
            });
            break;
          case 200:
          case 201:
            dispatch({
              response: response,
              type: UserLogoutActionDispatchTypes.USER_LOGOUT_SUCCESS,
            });
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.error(error);
      dispatch({
        error: error,
        type: UserLogoutActionDispatchTypes.USER_LOGOUT_ERROR,
      });
    }
  };
};

export const getRefreshToken: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Refresh_Token_SSO_ActionTypes
  >
> = (payload: RefreshTokenPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_INVOKE,
    });
    const response = await GetRefreshToken(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};